import React from 'react';
import { DivideIcon as LucideIcon } from 'lucide-react';

interface AdvantageCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

const AdvantageCard: React.FC<AdvantageCardProps> = ({ icon: Icon, title, description }) => {
  return (
    <div className="bg-light rounded-lg p-6 shadow-custom hover:shadow-custom-hover transition-shadow duration-300 flex flex-col items-center text-center">
      <div className="bg-primary/20 p-4 rounded-full mb-4">
        <Icon className="h-8 w-8 text-secondary" strokeWidth={1.5} />
      </div>
      <h3 className="font-abadi text-xl font-medium mb-3">{title}</h3>
      <p className="text-dark-gray">{description}</p>
    </div>
  );
};

export default AdvantageCard;